import loadable from '@loadable/component';
import type { FC } from 'react';
import React, { useMemo } from 'react';
import type { NodeViewRendererProps, NodeViewRenderers } from 'ricos-types';
import { Node_Type } from 'ricos-types';

const ImageRenderer: FC<NodeViewRendererProps> = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  const ViewerImage = useMemo(
    () => loadable(() => import(/* webpackChunkName: "ricos_plugin_image" */ './viewer-image')),
    []
  );
  return (
    <ViewerImage
      key={node.id}
      node={node}
      nodeIndex={nodeIndex}
      NodeViewContainer={NodeViewContainer}
      {...props}
    />
  );
};

const ImageLoadable = ({ node, ...props }: NodeViewRendererProps) => {
  return <ImageRenderer key={node.id} node={node} {...props} />;
};

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.IMAGE]: ImageLoadable,
};
